import React from "react";

import { CheckBox } from "./checkbox";

/*
 * Types
 */

export interface CheckBoxGroupProps {
    /*
     * Probably should just pass in report and destructure but since Parse can only type this
     * as an Object we need a way to provide more safety hence the custom typing below
     *
     * Hans H. 6 May 2020
     */
    readonly promotionProgress: Record<ConstituencyGroup, boolean>;
}

/*
 * Main
 */

export const CheckBoxGroup = (props: CheckBoxGroupProps): React.ReactElement => {
    const { promotionProgress } = props;

    return (
        <>
            <CheckBox checked={promotionProgress.students} data-testid="checkbox-progress-students">
                Students
            </CheckBox>
            <CheckBox checked={promotionProgress.teachers} data-testid="checkbox-progress-teachers">
                Teachers
            </CheckBox>
            <CheckBox checked={promotionProgress.administrators} data-testid="checkbox-progress-administrators">
                Administrators
            </CheckBox>
            <CheckBox checked={promotionProgress.supportStaff} data-testid="checkbox-progress-support-staff">
                Support Staff
            </CheckBox>
            <CheckBox checked={promotionProgress.parents} data-testid="checkbox-progress-parents">
                Parents
            </CheckBox>
            <CheckBox checked={promotionProgress.alumni} data-testid="checkbox-progress-board-alumni">
                Alumni
            </CheckBox>
            <CheckBox checked={promotionProgress.boardMembers} data-testid="checkbox-progress-board-members">
                Board Members
            </CheckBox>
        </>
    );
};
